import React, {useCallback, useContext, useEffect, useRef, useState} from 'react'
import {useTranslation} from "react-i18next";
import DataList from "../../../../../common/src/components/widget/DataList";
import {fetchUserPage} from "../../../state/api/userAPI";
import {getKey} from "../../../utils/InfiniteScroleUtil";
import {constructFilter} from "common/src/utils/AdvancedFilterApiUtils";
import {constructSort} from "common/src/utils/APIUtils";
import {useDispatch, useSelector} from "react-redux";
import {clearInfiniteScroll, fetchGroupPage} from "../../../state/api/groupAPI";
import {isEqual} from "lodash";
import {hasRole} from "../../../utils/userUtils";
import {Role} from "../../../auth/roles";
import {UserContext} from "../../../context/UserContext";

function UserList() {
    const {t} = useTranslation();
    const {user} = useContext(UserContext);
    const [filterString, setFilterString] = useState(getKey(constructFilter([])));
    const [sortString, setSortString] = useState(getKey(constructSort({ name: "asc" })));
    const total = useSelector(state => state.groupAPI.statesInfinitiveScrolls?.[filterString]?.totalElements);
    const totalPages = useSelector(state => state.groupAPI.statesInfinitiveScrolls?.[filterString]?.totalPages);

    const groupOptions = useSelector(state => state.groupAPI.statesInfinitiveScrolls?.[filterString]?.[sortString]?.content);
    const dispatch = useDispatch();
    const loadingGroups = useSelector(state => state.groupAPI.loading);
    const currentOptionsPage = useRef(-1);
    const optionsFilter = useRef(null);
    const [options, setOptions] = useState([]);


    useEffect(
        () => {
            dispatch(clearInfiniteScroll());
        }, []);
    useEffect(() => {
        if (!loadingGroups) {
            setOptions(groupOptions ?? []);
        }
    }, [total, totalPages, groupOptions, loadingGroups]);

    const onSearchQueryChange = useCallback((query) => {
            if (!isEqual(query, optionsFilter.current)) {
                optionsFilter.current = query;
                currentOptionsPage.current = 0;
            }

            const filter = query && query.trim() !== "" ? [{
                name: "name",
                operator: "LIKE_IC",
                value: `${query.trim()}`
            }] : [];
            const filterStringInternal = getKey(constructFilter(filter));
            const sortString = getKey(constructSort({ "name": "asc" }));
            setSortString(sortString);

            if (filterStringInternal && filterStringInternal !== "") {
                setFilterString(filterStringInternal);
            } else {
                setFilterString("blank");
            }
            const pageMod = totalPages || 1;
            dispatch(fetchGroupPage({
                page: {
                    page: (currentOptionsPage.current % pageMod),
                    size: 10,
                },
                sort: { "name": "asc" },
                filter
            }));
    }, [totalPages]);

    const onFetchNextPage = () => {
        if (!loadingGroups) {
            currentOptionsPage.current += 1;
            onSearchQueryChange(optionsFilter.current);
        }
    };

    return <DataList
        selector={(state) => state.userAPI.page}
        loadingSelector={(state) => state.userAPI.loading}
        fetchAction={fetchUserPage}
        columns={[
            {name: t('user.name'), id: "firstName"},
            {name: t('user.last_name'), id: "lastName"},
            {name: t('user.email'), id: "email"},
            {name: t('user.emailVerified'), id: "emailVerified"},
            {name: t('user.username'), id: "username"},
            {name: t('user.enabled'), id: "enabled"},
        ]}
        filterColumns={[
            {id: "firstName", type: "string", name: t('user.name')},
            {id: "lastName", type: "string", name: t('user.last_name')},
            {id: "email", type: "string", name: t('user.email')},
            {id: "emailVerified", type: "boolean", name: t('user.emailVerified')},
            {id: "username", type: "string", name: t('user.username')},
            {id: "enabled", type: "boolean", name: t('user.enabled')},
            {
                id: "groups.id",
                type: "findAndSelect",
                name: t('dataset.filter.labels.groups'),
                isMultiSelect: true,
                options: [...(options || [])],
                onSearchQueryChange,
                optionsLabel: "name",
                optionsValue: "id",
                optionsCode: "id",
                nullable: true,
                loading: loadingGroups,
                fetchMoreOptions: onFetchNextPage,
                hasMoreOptions: (total == null || (total > 0 && [...(options || [])].length < total)),
            },
        ]}

        defaultSort={"sort=username,asc"}
        showCreateButton={hasRole(user, Role.ADMIN_USERS)}
    />
}

export default UserList;
